// extracted by mini-css-extract-plugin
export default {"container":"style_container__B6A2j","divider":"style_divider__RXTh+","formFooter":"style_formFooter__FW2wB","button":"style_button__0Stvr"};